import React, { useEffect } from 'react';
import './BuiltFarmers.css';
import { FaCheck } from 'react-icons/fa';
import deliveryImage from '../../assets/Aboutimage/167627f9-e191-4e4f-a044-0e740fcb3de7 1.jpeg';

import { useNavigate } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';

const BuiltFarmers = () => {
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  return (
    <section className="built-farmers-section">
      <div className="container-fluid built-farmers-container py-5">
        <div className="row align-items-center">
          {/* Left Image */}
          <div className="col-md-6" data-aos="flip-left" data-aos-delay="500">
            <div className="image-wrapper d-flex justify-content-center">
              <img
                src={deliveryImage}
                alt="We Delivered"
                className="built-image img-fluid"
              />
            </div>
          </div>

          {/* Right Content */}
          <div className="col-md-6">
            <h2 className="about-us-heading" data-aos="fade-down" data-aos-delay="100">
              Built for Farmers. Backed by Tech
            </h2>

            <div className="built-features" data-aos="fade-right" data-aos-delay="300">
              <div className="feature">
                <div className="icon-circle"><FaCheck /></div>
                <span>No Middlemen – Keep more of your earnings</span>
              </div>
              <div className="feature">
                <div className="icon-circle"><FaCheck /></div>
                <span>Verified Buyers & Transparent Deals</span>
              </div>
              <div className="feature">
                <div className="icon-circle"><FaCheck /></div>
                <span>Access to Export Markets</span>
              </div>
              <div className="feature">
                <div className="icon-circle"><FaCheck /></div>
                <span>Logistic Assistance & Cold Chain Options</span>
              </div>
              <div className="feature">
                <div className="icon-circle"><FaCheck /></div>
                <span>Weekly Market Insights to Price Right</span>
              </div>
            </div>

            {/* Optional Button */}
            {/* <div data-aos="zoom-in" data-aos-delay="400">
              <button className="shop-button" onClick={() => navigate('/shop')}>
                Shop Now <span className="arrow">→</span>
              </button>
            </div> */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default BuiltFarmers;
